import { PessoaOdontologiaDto } from "./PessoaOdontologia.dto";
import { PessoaTerapiaOcupacionalDto } from "./PessoaTerapiaOcupacional.dto";
import { PessoaAssistenciaSocialDto } from "./PessoaAssistenciaSocial.dto";
import { PessoaFonoaudiologiaDto } from "./PessoaFonoaudiologia.dto";

export const PessoaDto = {
  id: "",
  nome: "",
  nascimento: null,
  RG: "",
  CPF: "",
  nomePai: "",
  nomeMae: "",
  nomeResponsavel: "",
  endereco: "",
  numeroEndereco: "",
  telefone: "",
  celular: "",
  telefoneRecado: "",
  diagnostico: "",
  CID: "",
  CEP: "",
  numeroSUSResponsavel: "",
  numeroSusReabilitando: "",
  numeroProntuario: "",
  bairro: {},
  sexoMasculino: true,
  planoSaude: false,
  odontologia: PessoaOdontologiaDto,
  fonoaudiologia: PessoaFonoaudiologiaDto,
  assistenciaSocial: PessoaAssistenciaSocialDto,
  terapiaOcupacional: PessoaTerapiaOcupacionalDto,
  horarioEscolar: "",
  nomeEscola: "",
  nascimentoResponsavel: null,
  CPFResponsavel: "",
};

export const PessoaHorarioEcolarDto = [
  "Matutino",
  "Vespertino",
  "Noturno",
  "Integral",
  "Não estuda",
];
